import { render, staticRenderFns } from "./ArticleTimeline.vue?vue&type=template&id=15226999&scoped=true"
import script from "./ArticleTimeline.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleTimeline.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ArticleTimeline.vue?vue&type=style&index=0&id=15226999&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15226999",
  null
  
)

export default component.exports